// The shader scripts of a filesystem (no Three.js: the map loading worker uses it too).

import type { VirtualFS } from '../fs/vfs';
import { parseShaderScript, type ShaderDef } from './shaderScripts';

/** Parses every scripts/*.shader file. */
export async function loadShaders(vfs: VirtualFS): Promise<Map<string, ShaderDef>> {
  const out = new Map<string, ShaderDef>();
  for (const path of vfs.list('scripts', '.shader')) {
    const text = await vfs.readText(path);
    if (!text) continue;
    try {
      parseShaderScript(text, out);
    } catch (err) {
      console.warn(`shader script ${path}:`, err);
    }
  }
  return out;
}
